import { Fragment } from 'react';
import { Container } from '@/components/container';
import {
  Toolbar,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
  ToolbarActions,
} from '@/partials/toolbar';
import { PageNavbar } from '@/pages/account';
import { useLayout } from '@/providers';
import { useNavigate } from 'react-router-dom';
import UserKYCTable from './components/UserKYCTable';

const UserKYC = () => {
  const { currentLayout } = useLayout();
  const navigate = useNavigate();

  return (
    <Fragment>
      <PageNavbar />
      {currentLayout?.name === 'demo1-layout' && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle text="User KYC" />
              <ToolbarDescription>
                View your KYC records here.
              </ToolbarDescription>
            </ToolbarHeading>
            <ToolbarActions>
              <button
                type="button"
                className="btn btn-sm btn-light"
                onClick={() => navigate('/user-kyc/add')}
                aria-label="Add new KYC"
              >
                Add KYC
              </button>
            </ToolbarActions>
          </Toolbar>
        </Container>
      )}
      <UserKYCTable />
    </Fragment>
  );
};

export { UserKYC };
